/**********************************************************
Chemical Application Create
**********************************************************/
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { addFertilizer, editFertilizer, selectFertilizerToEdit, deleteFertilizer,
  prepareData, setFertilizerForm, createOrEditFertilizerApplication,
  selectFertAppToEdit } from '../../actions/fertilizer_actions';
import { fetchFields, fetchEmployees, clearForm } from '../../actions/utils_actions';
import { packageForm, filterOldRecords } from '../../cult_utils';
import FertilizerForm from './fertilizer_form';
import CultivationModal from '../cult_modal';
import FertilizerApplicationDisplay from './fert_app_display';
import FertilizerAppList from './fertilizer_list';

class FertilizerCreate extends Component {
  componentDidMount() {
    if (this.props.employees.length === 0) this.props.fetchEmployees();
  }
  render() {
    return (
      <div>
        <div className="row">
        { Object.keys(this.props.user).length === 0 ? ''
          : this.props.user.level >= 3 || this.props.user.positionTitle.match(/Cultivation/) ?
          <div>
            <div className="col s12 m3 l3 xl3">
              <div className="chem-container">
                <FertilizerAppList fertAppList={this.props.fertilizerApplications.filter(filterOldRecords)} employees={this.props.employees}
                  onClick={this.props.selectFertAppToEdit} />
              </div>
            </div>
            <div className="col s12 m9 l9 xl9">
              { this.props.editingApplication ?
                <span className="app-log-header blue-text">Editing Fertilizer Application</span>
              : '' }
              <FertilizerForm employees={this.props.employees} fields={this.props.fields} formId={'fertilizer-application-form'}
                chemicalList={this.props.chemicalList.filter((c) => c.type === 'Fertilizer' || c.type === 'Adjuvant')} fertilizerApplied={this.props.fertilizerApplied}
                fertAppId={this.props.fertAppId} isEditing={this.props.isEditing} solidOrLiquid={this.props.solidOrLiquid} application={this.props.application}
                editFertilizerApplied={this.props.editFertilizerApplied} fetchFields={this.props.fetchFields} addFertilizer={this.props.addFertilizer} editFertilizer={this.props.editFertilizer}
                setFertilizerForm={this.props.setFertilizerForm} selectFertilizerToEdit={this.props.selectFertilizerToEdit} deleteFertilizer={this.props.deleteFertilizer}
                createOrEditFertilizerApplication={this.props.createOrEditFertilizerApplication} />
              <div className="row">
                <div className="col s12">
                  <div className="card-footer">
                    <a className="waves-effect waves-light btn modal-trigger" href={'#fertilzer-app-prepare'}
                      onClick={() => this.props.prepareData({
                        user: this.props.user,
                        form: packageForm('fertilizer-application-form'),
                        fields: this.props.fields,
                        fertAppId: this.props.fertAppId,
                        employees: this.props.employees,
                        editingApplication: this.props.editingApplication,
                        fertilizerApplied: this.props.fertilizerApplied,
                        deletedFertilizers: this.props.deletedFertilizers
                      })}>
                      Prepare
                    </a>
                    <button className="btn btn-flat"
                      onClick={() => { this.props.clearForm('fertilizer-application-form');
                        this.props.clearForm('fert-used-form-S');
                        this.props.clearForm('fert-used-form-LD')
                      }}>Clear
                    </button>
                  </div>
                </div>
                {
                  CultivationModal(FertilizerApplicationDisplay)
                  // eslint-disable-next-line
                  ({
                    id: 'fertilzer-app-prepare',
                    footer: true,
                    createOrEdit: true,
                    onClick: () => this.props.createOrEditFertilizerApplication({
                      data: { ...this.props.application, deletedFertilizerApplied: this.props.deletedFertilizerApplied },
                      type: this.props.type,
                      path: this.props.path
                    }),
                    application: this.props.application,
                    employees: this.props.employees,
                    editingApplication: this.props.editingApplication,
                    chemicalList: this.props.chemicalList,
                    previousApplications: this.props.previousApplications
                  })
                }
              </div>
            </div>
          </div>
          : <h5>Unauthorized</h5>
        }
        </div>
      </div>
    );
  }
}



function mapStateToProps(state) {
  return {
    application: state.cultivation.fertilizer.app.application,
    chemicalList: state.cultivation.chemical.chemicalList,
    deletedFertilizerApplied: state.cultivation.fertilizer.app.deletedFertilizerApplied,
    eid: state.auth.user.guid,
    employees: state.cultivation.utils.employees,
    editingApplication: state.cultivation.fertilizer.app.editingApplication,
    editFertilizerApplied: state.cultivation.fertilizer.app.editFertilizerApplied,
    fields: state.cultivation.utils.fields,
    fertAppId: state.cultivation.fertilizer.app.fertAppId,
    fertilizerApplied: state.cultivation.fertilizer.app.fertilizerApplied,
    fertilizerApplications: state.cultivation.fertilizer.fertilizerApplications.displaying,
    isEditing: state.cultivation.fertilizer.app.isEditing,
    path: state.cultivation.fertilizer.app.path,
    previousApplications: state.cultivation.fertilizer.app.previousApplications,
    solidOrLiquid: state.cultivation.fertilizer.app.solidOrLiquid,
    type: state.cultivation.fertilizer.app.type,
    user: state.auth.user
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    addFertilizer,
    createOrEditFertilizerApplication,
    clearForm,
    deleteFertilizer,
    editFertilizer,
    fetchEmployees,
    fetchFields,
    prepareData,
    selectFertilizerToEdit,
    selectFertAppToEdit,
    setFertilizerForm
  }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(FertilizerCreate);



/* END */



// WEBPACK FOOTER //
// ./src/cultivation/components/fertilizer/fertilizer_create.js